export const CheckDone: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#309269"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M16.22 5.573 10 11.771 7.469 9.24"
    ></path>
    <path
      stroke="#309269"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M16.903 8.43a7.083 7.083 0 1 1-2.855-4.238"
    ></path>
  </svg>
);
